import { DELIVERY_LABEL, type EmailDelivery } from "@clevis/shared-types";
import { cn } from "@clevis/shared-ui";

// What happened to an email after it left, as the email service reported it.
// "sent" means no news yet (or delivery reports aren't switched on).

const TONE: Record<EmailDelivery["status"], string> = {
  sent: "bg-steel/10 text-steel",
  delayed: "bg-brandorange/15 text-brandorange-dark",
  delivered: "bg-success/15 text-success",
  opened: "bg-success/15 text-success",
  bounced: "bg-danger/15 text-danger",
  complained: "bg-danger/15 text-danger",
};

export function DeliveryChip({ delivery }: { delivery?: EmailDelivery | null }) {
  const d = delivery ?? null;
  const status = d?.status ?? "sent";
  const when = d ? new Date(d.at).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
  return (
    <span className={cn("inline-block rounded-full px-1.5 py-px text-[10px] font-medium", TONE[status])} title={d ? `${DELIVERY_LABEL[status]} ${when}${d.detail ? `: ${d.detail}` : ""}` : "No delivery news yet"}>
      {DELIVERY_LABEL[status]}
    </span>
  );
}
